// Vendor
import { CommonModule } from '@angular/common';
// Modules
import { AddButtonAutocompleteModule } from 'SearchApp/ts/features/add-button-autocomplete/add-button-autocomplete.module';
import { BaseAutocompleteModule } from 'SearchApp/ts/features/base-autocomplete/base-autocomplete.module';
import { ConfigModule } from 'NewAngular/config/config.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class EditHoldingsModalModule {
}
EditHoldingsModalModule.ɵfac = function EditHoldingsModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || EditHoldingsModalModule)(); };
EditHoldingsModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: EditHoldingsModalModule });
EditHoldingsModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AddButtonAutocompleteModule,
        BaseAutocompleteModule,
        CommonModule,
        ConfigModule,
        IconModule,
        FeatureNeededModule,
        ModalBaseModule,
        TooltipModule] });
